import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IBMRProcess } from 'src/app/domain/IBMR/IBMR-process';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { IBMRService } from 'src/app/services/ibmr.service';
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { ERecouvrement } from 'src/app/domain/IBMR/enum/recouvrement';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { EAbondancePeriphyton } from 'src/app/domain/IBMR/enum/abondance-periphyton';
import { EModeMesure } from 'src/app/domain/Shared/enum/mode-mesure';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { EModeEstimationRecouvrement } from 'src/app/domain/IBMR/enum/mode-estimation-recouvrement';
import { EModePrelevement } from 'src/app/domain/IBMR/enum/mode-prelevement';
import { Transect } from 'src/app/domain/IBMR/transect';
import { MPCEMGCEMeasureBoxComponent } from 'src/app/tools/ui/mpce-mgce-measure-box/mpce-mgce-measure-box.component';
import * as _ from 'lodash'
import { EUniteUR1 } from 'src/app/domain/IBMR/enum/unite-ur1';
import { EUniteUR2 } from 'src/app/domain/IBMR/enum/unite-ur2';
import { IBMRUniteReleve } from 'src/app/domain/IBMR/IBMR-unite-releve';
import { IBMRVegetationAquatique } from 'src/app/domain/IBMR/IBMR-vegetation-aquatique';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';
import { Analyse } from 'src/app/domain/Analyse/analyse';
import { TaxonIBMRBoxComponent } from 'src/app/tools/ui/taxon-ibmr-box/taxon-ibmr-box.component';
import { Taxon } from 'src/app/domain/IBMR/IBMR-taxon';
import { EUnit } from 'src/app/domain/IBMR/enum/unit';

@Component({
    selector: 'app-ibmr',
    templateUrl: './ibmr.component.html',
    styleUrls: ['./ibmr.component.scss']
})
export class IBMRComponent implements OnInit {
    private MESURE_MAX = 10;
    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 0,
                Text: undefined,
                Icon: 'save'
            },
        ];

    public RecouvrementList: string[] =
        Object.values(ERecouvrement)
            .filter(x => !isNaN(Number(x)))
            .map((x: ERecouvrement) => StringConverter.getIBMRRecouvrementName(x));

    public AbondancePeriphytonList: string[] =
        Object.values(EAbondancePeriphyton)
            .filter(x => !isNaN(Number(x)))
            .map((x: EAbondancePeriphyton) => StringConverter.getAbondancePeriphytonName(x));

    public ModeMesureList: string[] =
        Object.values(EModeMesure)
            .filter(x => !isNaN(Number(x)))
            .map((x: EModeMesure) => StringConverter.getModeMesureName(x));

    public ModeEstimationRecouvrementList: string[] =
        Object.values(EModeEstimationRecouvrement)
            .filter(x => !isNaN(Number(x)))
            .map((x: EModeEstimationRecouvrement) => StringConverter.getModeEstimationRecouvrementName(x));

    public ModePrelevementList: string[] =
        Object.values(EModePrelevement)
            .filter(x => !isNaN(Number(x)))
            .map((x: EModePrelevement) => StringConverter.getModePrelevementName(x));

    public UniteUR1List: string[] =
        Object.values(EUniteUR1)
            .filter(x => !isNaN(Number(x)))
            .map((x: EUniteUR1) => StringConverter.getUniteUR1Name(x));

    public UniteUR2List: string[] =
        Object.values(EUniteUR2)
            .filter(x => !isNaN(Number(x)))
            .map((x: EUniteUR2) => StringConverter.getUniteUR2Name(x));

    public COMMENT_MAX_SIZE = 200;
    IsAmontX2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkXAgainstAval(),
        Validators.pattern(/^(\d{6})?$/)]));
    IsAvalX2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkXAgainstAmont(),
        Validators.pattern(/^(\d{6})?$/)]));

    IsAmontY2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkYAgainstAval(),
        Validators.pattern(/^(\d{7})?$/)]));
    IsAvalY2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkYAgainstAmont(),
        Validators.pattern(/^(\d{7})?$/)]));
    ValidAmontMaxLength = new UntypedFormControl('', [Validators.maxLength(this.COMMENT_MAX_SIZE)]);
    ValidAvalMaxLength = new UntypedFormControl('', [Validators.maxLength(this.COMMENT_MAX_SIZE)]);

    // IsRecouvrementUR1ValidControl = new FormControl('', Validators.compose([
    //     this.isRecouvrementUR1Valid()
    // ]))
    // IsRecouvrementUR2ValidControl = new FormControl('', Validators.compose([
    //     this.isRecouvrementUR2Valid()
    // ]))

    public IBMRProcess: IBMRProcess = new IBMRProcess();
    private interventionType: EInterventionType;
    private interventionCode: string;
    public Analyse: Analyse = new Analyse()

    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        private coreData: CoreData,
        private iBMRService: IBMRService,
        private snackBar: MatSnackBar,
        private router: Router,
        private dialog: MatDialog,
        private route: ActivatedRoute
    ) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.save(true);
            }
        })
    }

    ngOnInit() {
        if (!this.route.snapshot.params.processCode && !this.route.snapshot.params.interventionCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        this.interventionType = Number(this.route.snapshot.params.type) as EInterventionType;
        this.interventionCode = this.route.snapshot.params.interventionCode;
        this.IBMRProcess.Code = this.route.snapshot.params.processCode;
    }

    async ngAfterContentInit(): Promise<void> {
        if (this.coreData.IsOffline) {
            this.IBMRProcess = this.coreData.getOfflineProcess(this.route.snapshot.params.processCode) as IBMRProcess;
            this.Analyse = this.coreData.getOfflineAnalyse(this.route.snapshot.params.interventionCode);
        } else {
            await this.getProcessFromServer(this.route.snapshot.params.processCode);
        }

        this.ValidAmontMaxLength.markAsTouched();
        this.ValidAvalMaxLength.markAsTouched();
        this.IsAmontX2FarControl.markAsTouched();
        this.IsAvalX2FarControl.markAsTouched();
        this.IsAmontY2FarControl.markAsTouched();
        this.IsAvalY2FarControl.markAsTouched();

        // this.IsRecouvrementUR1ValidControl.markAsTouched();
        // this.IsRecouvrementUR2ValidControl.markAsTouched();

        setTimeout(() => {
            this.IsAvalX2FarControl.updateValueAndValidity();
            this.IsAmontX2FarControl.updateValueAndValidity();
            this.IsAvalY2FarControl.updateValueAndValidity();
            this.IsAmontY2FarControl.updateValueAndValidity();
            // this.IsRecouvrementUR1ValidControl.updateValueAndValidity();
            // this.IsRecouvrementUR2ValidControl.updateValueAndValidity();
        }, 0);
    }

    getUnitName(unit: EUnit) {
        return StringConverter.getUnitName(unit)
    }

    async getProcessFromServer(processCode: string) {

        await new Promise((resolve, reject) => {
            this.iBMRService.getProcessByCode(processCode).subscribe(x => {
                this.IBMRProcess = x;
                resolve(true);
            });
        })
    }

    onAmontXKeyUpEvent($event) {
        this.IsAvalX2FarControl.updateValueAndValidity();
    }
    onAvalXKeyUpEvent($event) {
        this.IsAmontX2FarControl.updateValueAndValidity();
    }
    onAmontYKeyUpEvent($event) {
        this.IsAvalY2FarControl.updateValueAndValidity();
    }
    onAvalYKeyUpEvent($event) {
        this.IsAmontY2FarControl.updateValueAndValidity();
    }

    // onRecouvrementUR1Event($event) {
    //     this.IsRecouvrementUR2ValidControl.updateValueAndValidity();
    // }
    // onRecouvrementUR2Event($event) {
    //     this.IsRecouvrementUR1ValidControl.updateValueAndValidity();
    // }

    checkXAgainstAmont(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.IBMRProcess && this.IBMRProcess.LocalisationStation &&
                !(Math.abs(control.value - this.IsAmontX2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkXAgainstAval(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.IBMRProcess && this.IBMRProcess.LocalisationStation &&
                !(Math.abs(control.value - this.IsAvalX2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkYAgainstAmont(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.IBMRProcess && this.IBMRProcess.LocalisationStation &&
                !(Math.abs(control.value - this.IsAmontY2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkYAgainstAval(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.IBMRProcess && this.IBMRProcess.LocalisationStation &&
                !(Math.abs(control.value - this.IsAvalY2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    // isRecouvrementUR1Valid(): ValidatorFn {
    //     return (control: AbstractControl): { [key: string]: any } | null =>
    //         this.IBMRProcess &&
    //             (control.value + (this.IsRecouvrementUR2ValidControl.value === '' ? 0 : this.IsRecouvrementUR2ValidControl.value) === 100)
    //             ? null : { wrongColor: control.value };
    // }

    // isRecouvrementUR2Valid(): ValidatorFn {
    //     return (control: AbstractControl): { [key: string]: any } | null =>
    //         this.IBMRProcess &&
    //             (control.value + this.IsRecouvrementUR1ValidControl.value === 100)
    //             ? null : { wrongColor: control.value };
    // }

    TypeOfUnitChanged(event: MatSelectChange, urIndex: number) {
        if (!event)
            return;
        this.IBMRProcess.HasUR2 = true;
        if (urIndex === 1 && event.value === 6) {// Unique
            this.IBMRProcess.HasUR2 = false;
            this.IBMRProcess.IBMRUniteReleve2.Recouvrement = 0;
        }
        else if (urIndex === 1)
            this.IBMRProcess.IBMRUniteReleve1.TypeUnite = event.value;
        else if (urIndex === 2)
            this.IBMRProcess.IBMRUniteReleve2.TypeUnite = event.value;

    }

    // ValidRecouvrement() {
    //     if (!this.IBMRProcess.HasUR2)
    //         return this.IsRecouvrementUR1ValidControl.valid
    //     else
    //         return this.IsRecouvrementUR1ValidControl.valid && this.IsRecouvrementUR2ValidControl.valid
    // }

    ValidateSubstratClasses(ur: IBMRUniteReleve) {

        const min = this.getMinValueForClasse(ur.IBMRSubstrat.Artificiel) +
            this.getMinValueForClasse(ur.IBMRSubstrat.BlocDalle) +
            this.getMinValueForClasse(ur.IBMRSubstrat.DebrisOrganique) +
            this.getMinValueForClasse(ur.IBMRSubstrat.PierreGalet) +
            this.getMinValueForClasse(ur.IBMRSubstrat.RacineBranchage) +
            this.getMinValueForClasse(ur.IBMRSubstrat.SableGravier) +
            this.getMinValueForClasse(ur.IBMRSubstrat.VaseLimon) +
            this.getMinValueForClasse(ur.IBMRSubstrat.TerreArgileMarne) +
            (ur.IBMRSubstrat.AutreDescription?.length > 0 ? this.getMinValueForClasse(ur.IBMRSubstrat.Autre) : 0)

        const max = this.getMaxValueForClasse(ur.IBMRSubstrat.Artificiel) +
            this.getMaxValueForClasse(ur.IBMRSubstrat.BlocDalle) +
            this.getMaxValueForClasse(ur.IBMRSubstrat.DebrisOrganique) +
            this.getMaxValueForClasse(ur.IBMRSubstrat.PierreGalet) +
            this.getMaxValueForClasse(ur.IBMRSubstrat.RacineBranchage) +
            this.getMaxValueForClasse(ur.IBMRSubstrat.SableGravier) +
            this.getMaxValueForClasse(ur.IBMRSubstrat.VaseLimon) +
            this.getMaxValueForClasse(ur.IBMRSubstrat.TerreArgileMarne) +
            (ur.IBMRSubstrat?.AutreDescription?.length > 0 ? this.getMaxValueForClasse(ur.IBMRSubstrat.Autre) : 0)

        return min <= 100 && max >= 100;
    }

    ValidateVitesseCourantClasses(ur: IBMRUniteReleve) {

        const min = this.getMinValueForClasse(ur.IBMRVitesseCourant.VEntre005Et02) +
            this.getMinValueForClasse(ur.IBMRVitesseCourant.VEntre02Et05) +
            this.getMinValueForClasse(ur.IBMRVitesseCourant.VEntre05Et1) +
            this.getMinValueForClasse(ur.IBMRVitesseCourant.VInferieur005) +
            this.getMinValueForClasse(ur.IBMRVitesseCourant.VSuperieur1)

        const max = this.getMaxValueForClasse(ur.IBMRVitesseCourant.VEntre005Et02) +
            this.getMaxValueForClasse(ur.IBMRVitesseCourant.VEntre02Et05) +
            this.getMaxValueForClasse(ur.IBMRVitesseCourant.VEntre05Et1) +
            this.getMaxValueForClasse(ur.IBMRVitesseCourant.VInferieur005) +
            this.getMaxValueForClasse(ur.IBMRVitesseCourant.VSuperieur1)

        return min <= 100 && max >= 100;
    }

    ValidateEclairementClasses(ur: IBMRUniteReleve) {

        const min = this.getMinValueForClasse(ur.IBMREclairement.Eclaire) +
            this.getMinValueForClasse(ur.IBMREclairement.Ombrage) +
            this.getMinValueForClasse(ur.IBMREclairement.PeuOmbrage) +
            this.getMinValueForClasse(ur.IBMREclairement.TresEclaire) +
            this.getMinValueForClasse(ur.IBMREclairement.TresOmbrage)

        const max = this.getMaxValueForClasse(ur.IBMREclairement.Eclaire) +
            this.getMaxValueForClasse(ur.IBMREclairement.Ombrage) +
            this.getMaxValueForClasse(ur.IBMREclairement.PeuOmbrage) +
            this.getMaxValueForClasse(ur.IBMREclairement.TresEclaire) +
            this.getMaxValueForClasse(ur.IBMREclairement.TresOmbrage)

        return min <= 100 && max >= 100;
    }

    ValidateProfondeurClasses(ur: IBMRUniteReleve) {

        const min = this.getMinValueForClasse(ur.IBMRProfondeur.PEntre01Et05) +
            this.getMinValueForClasse(ur.IBMRProfondeur.PEntre05Et1) +
            this.getMinValueForClasse(ur.IBMRProfondeur.PEntre1Et2) +
            this.getMinValueForClasse(ur.IBMRProfondeur.PInferieur01) +
            this.getMinValueForClasse(ur.IBMRProfondeur.PSuperieur2)

        const max = this.getMaxValueForClasse(ur.IBMRProfondeur.PEntre01Et05) +
            this.getMaxValueForClasse(ur.IBMRProfondeur.PEntre05Et1) +
            this.getMaxValueForClasse(ur.IBMRProfondeur.PEntre1Et2) +
            this.getMaxValueForClasse(ur.IBMRProfondeur.PInferieur01) +
            this.getMaxValueForClasse(ur.IBMRProfondeur.PSuperieur2)

        return min <= 100 && max >= 100;
    }

    ValidateFaciesEcoulementClasses(ur: IBMRUniteReleve) {

        const min = this.getMinValueForClasse(ur.IBMRFaciesEcoulement.Cascade) +
            this.getMinValueForClasse(ur.IBMRFaciesEcoulement.ChenalLentique) +
            this.getMinValueForClasse(ur.IBMRFaciesEcoulement.ChenalLotique) +
            this.getMinValueForClasse(ur.IBMRFaciesEcoulement.FosseDissipation) +
            this.getMinValueForClasse(ur.IBMRFaciesEcoulement.Mouille) +
            this.getMinValueForClasse(ur.IBMRFaciesEcoulement.PlatCourant) +
            this.getMinValueForClasse(ur.IBMRFaciesEcoulement.PlatLentique) +
            this.getMinValueForClasse(ur.IBMRFaciesEcoulement.Radier) +
            this.getMinValueForClasse(ur.IBMRFaciesEcoulement.Rapide) +
            this.getMinValueForClasse(ur.IBMRFaciesEcoulement.ZoneDeBordure) +
            (ur.IBMRFaciesEcoulement.AutreDescription?.length > 0 ? this.getMinValueForClasse(ur.IBMRFaciesEcoulement.Autre) : 0)

        const max = this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.Cascade) +
            this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.ChenalLentique) +
            this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.ChenalLotique) +
            this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.FosseDissipation) +
            this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.Mouille) +
            this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.PlatCourant) +
            this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.PlatLentique) +
            this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.Radier) +
            this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.Rapide) +
            this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.ZoneDeBordure) +
            (ur.IBMRFaciesEcoulement?.AutreDescription?.length > 0 ? this.getMaxValueForClasse(ur.IBMRFaciesEcoulement.Autre) : 0)

        return min <= 100 && max >= 100;
    }

    getMinValueForClasse(classe: ERecouvrement) {
        switch (classe) {
            case ERecouvrement.Absent:
                return 0;
            case ERecouvrement.Inferieur1:
                return 0;
            case ERecouvrement.Entre1Et10:
                return 1;
            case ERecouvrement.Entre10Et25:
                return 10;
            case ERecouvrement.Entre25Et75:
                return 25;
            case ERecouvrement.Superieur75:
                return 75;
        }
    }

    getMaxValueForClasse(classe: ERecouvrement) {
        switch (classe) {
            case ERecouvrement.Absent:
                return 0;
            case ERecouvrement.Inferieur1:
                return 1;
            case ERecouvrement.Entre1Et10:
                return 10;
            case ERecouvrement.Entre10Et25:
                return 25;
            case ERecouvrement.Entre25Et75:
                return 75;
            case ERecouvrement.Superieur75:
                return 100;
        }
    }

    getLpB(i) {
        return `Lpb ${i + 1}`;
    }

    getLongueur(i) {
        return `L ${i + 1}`;
    }

    getLm(i) {
        return `Lm ${i + 1}`;
    }

    computeSurface() {
        return this.computeLongueurStation() * this.computeLmMoy();
    }

    computeLpBMoy() {
        if (this.IBMRProcess.IBMRMesureStation.LargeurStations.filter(y => y.LpB > 0).length === 0) {
            return 0;
        }
        return _.sum(this.IBMRProcess.IBMRMesureStation.LargeurStations.map(x => x.LpB)) / this.IBMRProcess.IBMRMesureStation.LargeurStations.filter(y => y.LpB > 0).length;
    }

    computeLmMoy() {
        if (!this.IBMRProcess.HasUR2) {
            return this.computeRecouvrementUR1() * this.computeLargeurForUR(this.IBMRProcess.IBMRUniteReleve1) / 100;
        }
        return (this.computeRecouvrementUR1() * this.computeLargeurForUR(this.IBMRProcess.IBMRUniteReleve1) + this.computeRecouvrementUR2() * this.computeLargeurForUR(this.IBMRProcess.IBMRUniteReleve2)) / 100;
    }

    computeLongueurForUR(ur: IBMRUniteReleve) {
        ur.Longueur = _.sum(ur.IBMRTransectList.map(x => x.LpB));
        return ur.Longueur;
    }

    computeLargeurForUR(ur: IBMRUniteReleve) {
        ur.Largeur = _.sum(ur.IBMRTransectList.map(x => x.Lm * x.LpB)) / _.sum(ur.IBMRTransectList.map(x => x.LpB));
        return ur.Largeur;
    }

    computeRecouvrementUR1() {
        if (!this.IBMRProcess.HasUR2)
            return 100;
        return (this.IBMRProcess.IBMRUniteReleve1.Longueur * this.computeLargeurForUR(this.IBMRProcess.IBMRUniteReleve1)) /
            (this.IBMRProcess.IBMRUniteReleve1.Longueur * this.computeLargeurForUR(this.IBMRProcess.IBMRUniteReleve1) + (this.IBMRProcess.IBMRUniteReleve2.Longueur * this.computeLargeurForUR(this.IBMRProcess.IBMRUniteReleve2))) * 100;
    }

    computeRecouvrementUR2() {
        return 100 - this.computeRecouvrementUR1();
    }

    computeLongueurStation() {
        return this.IBMRProcess.IBMRUniteReleve1.Longueur + (this.IBMRProcess.IBMRUniteReleve2.Longueur ?? 0);
    }

    computeURSurfaceVegetaliseTotale(ur: IBMRUniteReleve) {
        ur.SurfaceVegetalisee = 0.0;
        ur.SurfaceVegetalisee += (ur.IBMRVegetationAquatique.Algues ? ur.IBMRVegetationAquatique.Algues : 0.0)
        ur.SurfaceVegetalisee += (ur.IBMRVegetationAquatique.Helophytes ? ur.IBMRVegetationAquatique.Helophytes : 0.0)
        ur.SurfaceVegetalisee += (ur.IBMRVegetationAquatique.Heterotrophes ? ur.IBMRVegetationAquatique.Heterotrophes : 0.0)
        ur.SurfaceVegetalisee += (ur.IBMRVegetationAquatique.Bryophytes ? ur.IBMRVegetationAquatique.Bryophytes : 0.0)
        ur.SurfaceVegetalisee += (ur.IBMRVegetationAquatique.HydrophytesFlottants ? ur.IBMRVegetationAquatique.HydrophytesFlottants : 0.0)
        ur.SurfaceVegetalisee += (ur.IBMRVegetationAquatique.HydrophytesImmerges ? ur.IBMRVegetationAquatique.HydrophytesImmerges : 0.0)
        ur.SurfaceVegetalisee += (ur.IBMRVegetationAquatique.Phanerogames ? ur.IBMRVegetationAquatique.Phanerogames : 0.0)
        ur.SurfaceVegetalisee += (ur.IBMRVegetationAquatique.Pteridophytes ? ur.IBMRVegetationAquatique.Pteridophytes : 0.0)
        return ur.SurfaceVegetalisee;
    }

    ValidateVegationEquality(veg: IBMRVegetationAquatique) {
        return (veg.Heterotrophes + veg.Algues + veg.Bryophytes + veg.Pteridophytes + veg.Phanerogames).toFixed(2) === (veg.HydrophytesFlottants + veg.HydrophytesImmerges + veg.Helophytes).toFixed(2);
    }

    removeLargeur(measure: Transect) {
        // if (this.model.MesureStation.LargeurStations.length > 1) {
        //   this.model.MesureStation.LargeurStations.pop();
        // }
        _.remove(this.IBMRProcess.IBMRMesureStation.LargeurStations, x => x === measure);
    }

    removeTransect(measure: Transect, ur: IBMRUniteReleve) {
        // if (this.model.MesureStation.LargeurStations.length > 1) {
        //   this.model.MesureStation.LargeurStations.pop();
        // }
        _.remove(ur.IBMRTransectList, x => x === measure);
    }

    openMesureBox(largueur?: Transect) {
        if (this.IBMRProcess.IBMRMesureStation.LargeurStations.length >= this.MESURE_MAX) {
            NotificationManager.handleWarning(`Le nombre maximal de mesure est de ${this.MESURE_MAX}`, this.snackBar);
            return;
        }

        const dialogRef = this.dialog.open(MPCEMGCEMeasureBoxComponent, {
            // data: Object.assign({}, largueur) ?? new LargeurStation(),
            data: {
                mesure: Object.assign({}, largueur) ?? new Transect(),
                type: EInterventionType.IBMR,
            },
            width: '333px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Transect) => {
            if (!result)
                return;

            if (!largueur) {
                this.IBMRProcess.IBMRMesureStation.LargeurStations.push(result);
            } else {
                Object.assign(largueur, result);
            }
        });
    }

    openMesureBoxForTransect(ur: IBMRUniteReleve, largueur?: Transect) {

        const dialogRef = this.dialog.open(MPCEMGCEMeasureBoxComponent, {
            // data: Object.assign({}, largueur) ?? new LargeurStation(),
            data: {
                mesure: largueur ? Object.assign({}, largueur) : new Transect(),
                type: EInterventionType.IBMR,
                isForTransect: true
            },
            width: '333px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Transect) => {
            if (!result)
                return;

            if (!largueur) {
                ur.IBMRTransectList.push(result);
            } else {
                Object.assign(largueur, result);
            }
        });
    }

    openTaxonIBMRBox(transect: Transect, taxon?: Taxon) {
        const dialogRef = this.dialog.open(TaxonIBMRBoxComponent, {

            data: {
                taxon: taxon,
                transectAlreadyPicked: transect.TaxonList,
                fullIBMRAlreadyPicked: [
                    ...this.IBMRProcess.IBMRUniteReleve1.IBMRTransectList.map(x => x.TaxonList).flat(),
                    ...this.IBMRProcess.IBMRUniteReleve2.IBMRTransectList.map(x => x.TaxonList).flat()]
            },
            width: '333px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Taxon) => {
            if (!result)
                return;

            if (taxon)
                Object.assign(taxon, result)
            else
                transect.TaxonList.push(result);
        });
    }

    deleteTaxon(transect: Transect, taxon: Taxon) {
        _.remove(transect.TaxonList, x => (x.Code && x.Code === taxon.Code) || (x.CustomName && x.CustomName === taxon.CustomName))
    }

    CanSave() {
        return true;
        // return this.ValidateSubstratClasses(this.IBMRProcess.IBMRUniteReleve1) &&
        //     this.ValidateEclairementClasses(this.IBMRProcess.IBMRUniteReleve1) &&
        //     this.ValidateFaciesEcoulementClasses(this.IBMRProcess.IBMRUniteReleve1) &&
        //     this.ValidateProfondeurClasses(this.IBMRProcess.IBMRUniteReleve1) &&
        //     this.ValidateVitesseCourantClasses(this.IBMRProcess.IBMRUniteReleve1) &&
        //     (this.IBMRProcess.HasUR2 ? this.ValidateSubstratClasses(this.IBMRProcess.IBMRUniteReleve2) : true) &&
        //     (this.IBMRProcess.HasUR2 ? this.ValidateEclairementClasses(this.IBMRProcess.IBMRUniteReleve2) : true) &&
        //     (this.IBMRProcess.HasUR2 ? this.ValidateFaciesEcoulementClasses(this.IBMRProcess.IBMRUniteReleve2) : true) &&
        //     (this.IBMRProcess.HasUR2 ? this.ValidateProfondeurClasses(this.IBMRProcess.IBMRUniteReleve2) : true) &&
        //     (this.IBMRProcess.HasUR2 ? this.ValidateVitesseCourantClasses(this.IBMRProcess.IBMRUniteReleve2) : true);
    }

    save(forced: boolean) {

        if (!this.CanSave() && !forced) {
            NotificationManager.handleError('Les données ne sont pas valides', this.snackBar);
            return;
        }

        // For the server
        this.IBMRProcess.IBMRMesureStation.Longueur = this.computeLongueurStation();
        this.IBMRProcess.IBMRMesureStation.LmMoyenne = this.computeLmMoy();
        this.IBMRProcess.IBMRMesureStation.SurfaceTotale = this.computeSurface();
        this.IBMRProcess.IBMRUniteReleve1.Largeur = this.computeLargeurForUR(this.IBMRProcess.IBMRUniteReleve1);
        if (this.IBMRProcess.HasUR2)
            this.IBMRProcess.IBMRUniteReleve2.Largeur = this.computeLargeurForUR(this.IBMRProcess.IBMRUniteReleve2);

        if (this.coreData.IsOffline) {
            this.coreData.setOfflineProcess(this.IBMRProcess);
            NotificationManager.handleSuccess(`Intervention enregistrée`, this.snackBar);
        } else {
            this.iBMRService.updateProcess(this.IBMRProcess).subscribe(x => {
                NotificationManager.handleSuccess('Intervention enregistrée', this.snackBar);
            });
        }
    }

    dispatch(event: SpeedDialFabModel) {

        switch (event.Id) {
            case 0:
                this.save(false);
                break;
        }
    }
}
